export const REQUEST_SCA_PROCEDURE_SUCCESS = 'REQUEST_SCA_PROCEDURE_SUCCESS';
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type REQUEST_SCA_PROCEDURE_SUCCESS =
  typeof REQUEST_SCA_PROCEDURE_SUCCESS;
